import React from 'react';
import PropTypes from 'prop-types';
import { TextEditor } from '../../../Modules';

export default class BrandFields extends React.Component {

  static propTypes = {
    selectedBrand: PropTypes.object.isRequired,
    localBrand: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    submitted: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);
    this.fieldChange = this.fieldChange.bind(this);
    this.textFieldChange = this.textFieldChange.bind(this);
  }

  textFieldChange(value) {
    this.fieldChange('brand_header', value);
  }

  fieldChange(key, value) {
    const newValue = {};
    newValue[key] = value;
    this.props.onChange(Object.assign({}, this.props.localBrand, newValue));
  }

  render() {
    return (
      <TextEditor
        value={this.props.localBrand.brand_header || ''}
        onChange={this.textFieldChange}
        placeholder='Brand header information'
      />
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Brand/BrandFields.js